import Cookie from "js-cookie"
import { api_appuserinfo } from '@/api/login'

function isLocal(){
    return location.host.startsWith('localhost') || location.host.startsWith('172.')
}

export default {
    namespaced: true,
    state: {
        loginId: '',
        nickname: '请登录',
        avatar: require('@/assets/images/default_avatar.png'),
        phone: '',
        isLoginToastShow: false, //控制登录弹窗是否弹出
        authorization: '',
        isRegister: false,
        loginToastType: 'login',
        loginstate: false,
        webSocketData: {},
        thirdAvatar: '',
        thirdNickName: '',
        openId: '',
        loginMethod: '',
        agreementPath: '',
        isAgree: '',
        registerData: {},
        allUnreada: true,
        indexData: [],
        indexDataShow: false,
        username: "",
        version: "",
        newLoginId: "",
        smsKey: '',
        imgUrl:'https://laozi-autopublic-east.obs.cn-east-2.myhuaweicloud.com/',
    },
    mutations: {
        setUpdataAuth(state,data){
            state.authorization=data;
        },
        SETLOGINID(state, data) {
            state.loginId = data
            // if (isLocal()) {
            //   Cookie.set('loginId', data)
            // } else {
            //   Cookie.set('loginId', data, { domain: domain })
            // }
        },
        SETAVATAR(state, data) {
            state.avatar = data.avatar;
            state.nickname = data.nickname;
        },
        ISREGISTER(state, data) {
            state.isRegister = data
        },
        GETMSG(state, data) {
            state.allUnreada = data
        },
        GETINDEXData(state, data) {
    
            state.indexData = []
            state.indexData = data
        },
        SETUSERINFO(state, data) {
            state.loginId = data.id
            var domain = 'laozicloud.com'
            if( location.origin.includes( 'laozicloud.net' ) ){
                domain = 'laozicloud.net'
            }
            if (isLocal()) {
                Cookie.set('loginId', data.id)
            } else {
                Cookie.set('loginId', data.id, {
                    domain: domain
                })
            }
            state.nickname = data.nickname
            state.avatar = data.avatar ? data.avatar : require('@/assets/images/default_avatar.png')
            state.phone = data.phone
            state.loginstate = true
            state.username = data.username;
            state.newLoginId = data.loginid;
            state.imgUrl='https://laozi-autopublic-east.obs.cn-east-2.myhuaweicloud.com/';
        },
        SETAUTHORIZATION(state, data) { //登录令牌
            state.authorization = 'bearer ' + data
            var domain = 'laozicloud.com'
            if( location.origin.includes( 'laozicloud.net' ) ){
                domain = 'laozicloud.net'
            }
            if (isLocal()) {
                Cookie.set('authorization', data)
            } else {
                Cookie.set('authorization', data, {
                    domain: domain
                })
            }
            state.loginstate = true
            state.indexDataShow = true
            Cookie.set('loginstate', true)
        },
        QUIT(state) {
            state.authorization = ''
            state.loginId = ''
            state.nickname = '请登录'
            state.avatar = require('@/assets/images/default_avatar.png')
            state.phone = ''
            state.loginstate = false
            state.indexDataShow = false
            Cookie.remove('loginstate')
            Cookie.remove('loginId')
            localStorage.removeItem('loginId')
            var domain = 'laozicloud.com'
            if( location.origin.includes( 'laozicloud.net' ) ){
                domain = 'laozicloud.net'
            }
            if (isLocal()) {
                Cookie.remove('authorization')
                Cookie.remove('loginId')
            } else {
                Cookie.remove('authorization', {
                    domain: domain
                })
                Cookie.remove('loginId', {
                    domain: domain
                })
            }
            Cookie.remove('loginstate');
        },
        ISLOGINTOASTSHOW() {
            // var url = process.env.Mode == 'pro' ? 'https://www.laozicloud.net/loginSystem' : 'https://www.laozicloud.com/loginSystem'
            // if (location.origin.includes('localhost')) url = 'http://localhost:8080'
            // location.href = `${url}/?returnURL=${encodeURIComponent(location.href)}`
            var url = process.env.MODE == 'pro'? 'https://www.laozicloud.com/loginSystem' : 'https://www.laozicloud.net/loginSystem'
            if(location.origin.includes('localhost')) url = 'http://localhost:8080'
            // zh的本地路径登录需要添加多个复制一行else if 即可
            else if (location.origin.includes('172.16.10')) url = 'http://172.16.10.243:8080'
            location.href = `${url}/?returnURL=${encodeURIComponent(location.href)}`
        },
        LOGINTOASTTYPE(state, data) { //登录框当前内容 eg.注册 登录 找回密码
            // state.loginToastType = data
        },
        CHANGESOCKET(state, data) { // // 改变消息队列数据
            state.webSocketData = data
        },
        SETTHIRDAVATAR(state, data) { // 设置第三方登录头像
            state.thirdAvatar = data
        },
        SETTHIRDNICKNAME(state, data) { // 设置第三方登录名称
            state.thirdNickName = data
        },
        SETTHIRDOPENID(state, data) { // 设置第三方登录openid
            state.openId = data
        },
        SETLOGINMETHOD(state, data) { // 设置第三方登录方法 wx or qq
            state.loginMethod = data
        },
        SETAGREEMENTPATH(state, data) { // 关闭用户协议，跳回上一层
            state.agreementPath = data
        },
        SETISAGREE(state, data) { //是否同意用户协议
            state.isAgree = data
        },
        SETREGISTERDATA(state, data) {
            state.registerData = data
        },
        SETTHIRDINFO(state, data) {// 设置第三方登录openid
            state.openId = data.openId
            state.loginMethod = data.loginMethod
            state.thirdAvatar = data.thirdAvatar
            state.thirdNickName = data.thirdNickName
        }
    },
    actions: {
        async GETUSERINFO(context) {
                let that =this
                const res = await api_appuserinfo()
                let J = JSON.parse(res.datas)
                context.commit('SETUSERINFO', J)
        }
    },
    modules: {
    },

}

